import { atom } from "jotai";

const optionSpecialInstructionsAtom = atom<Record<string, Record<string, string>>>({})

export default optionSpecialInstructionsAtom
